import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { WebGLRenderTarget } from './WebGLRenderTarget.js';

var WebGLMultisampleRenderTarget = /*#__PURE__*/function (_WebGLRenderTarget) {
  _inheritsLoose(WebGLMultisampleRenderTarget, _WebGLRenderTarget);

  function WebGLMultisampleRenderTarget(width, height, options) {
    var _this;

    _this = _WebGLRenderTarget.call(this, width, height, options) || this;
    _this.samples = 4;
    return _this;
  }

  var _proto = WebGLMultisampleRenderTarget.prototype;

  _proto.copy = function copy(source) {
    _WebGLRenderTarget.prototype.copy.call(this, source);

    this.samples = source.samples;
    return this;
  };

  return WebGLMultisampleRenderTarget;
}(WebGLRenderTarget);

WebGLMultisampleRenderTarget.prototype.isWebGLMultisampleRenderTarget = true;
export { WebGLMultisampleRenderTarget };